import {  get } from "../../service/api";

const GetVatMerchantById = async (merchantId,vatMerchantId) => {
    try {
        const response = await get(`/merchant/${merchantId}/vatMerchant/${vatMerchantId}`);
        return response.data;
    } catch (error) {
        console.error('Error GetVatMerchantById:', error);
        throw error;
    }
};

export default GetVatMerchantById;